module.exports = __webpack_public_path__ + "img/y-141.c5f1ef6b.png";